export default __webpack_public_path__ + "static/media/HospitalityWay.8e95c445.png";